/**
 * Einsatzstellen (KONZEPT.md §6).
 *
 * Eine Einsatzstelle entsteht im Betrieb, nicht in der Stammdatenpflege: Die
 * erste Buchung legt sie an, ab dann scannt jeder nur noch.
 */
import { z } from "zod";
import { Id, KurzText, LangText, Zeitpunkt } from "./basis.js";
import { EinsatzstellenStatus } from "./enums.js";
/** Voreinstellung aus KONZEPT.md §6.1, je Einsatzstelle aenderbar (§6.2). */
export const VORSCHLAGSFRIST_TAGE_STANDARD = 3;
export const Einsatzstelle = z.object({
    id: Id,
    bezeichnung: KurzText,
    angelegt_von: Id,
    angelegt_am: Zeitpunkt,
    /** Zeitpunkt der letzten Buchung auf diese Stelle. */
    zuletzt_verwendet: Zeitpunkt.nullable(),
    status: EinsatzstellenStatus,
    /**
     * Wie lange die Stelle nach der letzten Buchung noch vorgeschlagen wird.
     *
     * Steht in der Einsatzstellen-Uebersicht und nicht in einer
     * Systemeinstellung: Bei einer mehrtaegigen Lage fiele die Stelle sonst aus
     * den Vorschlaegen, obwohl sie noch laeuft, und die Einsatzkraefte muessten
     * sie jedes Mal neu heraussuchen (KONZEPT.md §6.2).
     */
    vorschlagsfrist_tage: z.number().int().positive().max(365),
    /** Hebt die Frist auf -- fuer Lagen ueber Wochen. */
    dauerhaft_aktiv: z.boolean(),
    notiz: LangText.nullable(),
});
export const EinsatzstelleAnlegen = Einsatzstelle.omit({
    id: true,
    angelegt_am: true,
    zuletzt_verwendet: true,
}).extend({
    status: EinsatzstellenStatus.default("aktiv"),
    vorschlagsfrist_tage: z.number().int().positive().max(365).default(VORSCHLAGSFRIST_TAGE_STANDARD),
    dauerhaft_aktiv: z.boolean().default(false),
    notiz: LangText.nullable().default(null),
});
//# sourceMappingURL=einsatzstelle.js.map